export const MAIN_COLOR = '#577CF0';
export const MAIN_HOVER_COLOR = '#4461BB';
export const FREE_SLOT = '#ACE96F';
export const BOOKED_SLOT = '#FFB36C';
export const FULL_SLOT = '#F75D61';
export const MAIN_BG_COLOR = '#F3F4F7';
export const SECONDARY_BG_COLOR = '#E3EBF4';
export const MAIN_TEXT_COLOR = '#577CF0';
export const TEXT_COLOR = '#060913';
export const TEXT_COLOR_OPACITY = '#06091333';
export const DARK_TEXT_COLOR = '#ffffff';
export const STAFF_COLOR = '#A1AAC6';
export const DISABLED_COLOR = '#E1E2E6';
export const DISABLED_INPUT_COLOR = '#a3b2c1';
export const DANGER_COLOR = '#F75D61';
export const SHADOW_COLOR = '#2D53C84D';
export const DANGER_LIGHT_HOVER_COLOR = 'rgba(241, 93, 93, 0.1)';
export const MAIN_LIGHT_HOVER_COLOR = 'rgba(87, 124, 240, 0.1)';
export const INFO_COLOR = '#B7CFFF';
export const DEFAULT_BG_COLOR = '#FFFFFF';
export const SUCCESS_COLOR = 'green';
export const NEUTRAL_COLOR = '#8e8f8f';
export const WARNING_COLOR = '#FFB36C';
export const STATUS_COLOR = '#272D43';
export const DARK_BLUE = '#272D43';
export const SCREEN_SM = 576;
export const SCREEN_MD = 768;
export const SCREEN_LG = 992;
export const SCREEN_XL = 1200;
export const SCREEN_XXL = 1400;